import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class EmailCampaignPresenterNavSteps extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    if (this.props.email_campaign){
      return (
        <div className="steps">
          {this.renderSteps()}
          <br />
        </div>
      );
    } else {
      return null
    }
  };

  renderSteps(){
    return(
      <ul className="nav nav-wizard">
        <li className={this.props.step == "general" ? 'active' : ''}><a href="#" data-step="general" >{I18n.t("general")}</a></li>
        <li className={this.props.step == "customer_details" ? 'active' : ''}><a href="#" data-step="customer-details" >{I18n.t("filter")}</a></li>
        <li className={this.props.step == "email_templates" ? 'active' : ''}><a href="#" data-step="email-templates" >{I18n.t("schedule")}</a></li>
        <li className={this.props.step == "customers_preview" ? 'active' : ''}><a href="#" data-step="customers-preview" >{I18n.t("preview")}</a></li>
      </ul>
    );
  };
};
